import React from 'react';
import { useIntl } from 'react-intl';
import Box from '@nubank/nuds-web/components/Box/Box';
import NuLogo from '@nubank/nuds-web/components/NuLogo/NuLogo';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';
import { useParallax } from 'react-scroll-parallax';

const BANK_SUBTITLE = 'Nubank es regulado y supervisado por la CNBV, el Banco de México y la Condusef para cuidar tus finanzas juntos.';
const BANK_LINK_TEXT = 'Descubre más sobre Nubank';

const BANK_IMAGE_SRC_SET = {
  xs: 'lite-version/security-bank.jpg',
  lg: 'lite-version/security-lg-bank.jpg',
};

const StyledTypography = styled(Typography)`
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  background: linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
`;

const StyledBox = styled(Box)`
  svg {
    transform: scale(1.4);
  }
`;

function SecurityAndTransparency() {
  const { formatMessage } = useIntl();
  const { ref } = useParallax({ speed: 3, easing: [0, -0.5, 0, -3] });

  const subtitle = BANK_SUBTITLE;

  const linkText = BANK_LINK_TEXT;

  const linkHref = formatMessage({ id: 'HOME.LITE_VERSION.SECURITY_SECTION.PATH' });

  const imageSrcSet = BANK_IMAGE_SRC_SET;

  return (
    <Box
      tag="section"
      display="flex"
      flexDirection="column"
      marginTop="32x"
      alignItems="center"
    >
      <StyledBox>

        <NuLogo variant="primary" />
      </StyledBox>

      <Box
        width="100%"
        marginTop="28x"
        paddingHorizontal={{ xs: '0', lg: '8vw', xl: '16vw' }}
      >
        <Grid
          paddingLeft="0"
          paddingRight="0"
        >

          {/* IMAGE */}

          <Grid.Child
            gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '2 / span 10' }}
            gridRow="1"
          >
            <Box ref={ref}>
              <Image
                alt="Dos personas miran su celular mientras ríen"
                srcSet={imageSrcSet}
                width={{ xs: '100vw', lg: '100%' }}
                height={{ xs: '100%' }}
                loading="lazy"
                webp
              />
            </Box>

          </Grid.Child>

          {/* CONTENT BOX */}

          <Grid.Child
            gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '4 / span 6' }}
            gridRow="1"
          >
            <Box
              backgroundColor="#F8F8FA"
              borderRadius="12px"
              paddingTop="60px"
              paddingHorizontal="8x"
              paddingBottom="42px"
              marginHorizontal={{ xs: '8x', lg: '0' }}
              marginTop={{ xs: '64%', lg: '50%' }}
              zIndex="2"
              position="relative"
              display="flex"
              flexDirection="column"
            >
              <Typography
                variant="heading3"
                intlKey="HOME.LITE_VERSION.SECURITY_SECTION.TITLE"
                paddingBottom="8x"
                intlValues={{
                  highlight: (
                    <StyledTypography
                      tag="span"
                      intlKey="HOME.LITE_VERSION.SECURITY_SECTION.TITLE.HIGHLIGHT"
                      variant="heading3"
                      color="primary"
                    />
                  ),
                }}
                whiteSpace={{ xs: 'pre-line', md: 'normal' }}
                paddingTop={{ xs: '0', md: '8x' }}
                textAlign={{ xs: 'left', md: 'center' }}
                maxWidth={{ xs: '15ch', lg: '17ch' }}
                margin={{ xs: '0', lg: '0 auto' }}
              />

              <Typography
                variant="subtitle1"
                marginBottom="8x"
                textAlign={{ xs: 'left', md: 'center' }}
                whiteSpace={{ xs: 'normal', md: 'pre-line' }}
              >
                {subtitle}
              </Typography>

              <Link
                href={linkHref}
                variant="action"
                color="primary"
                margin={{ xs: '0', md: '0 auto' }}
                alignSelf="center"
              >
                {linkText}
              </Link>

            </Box>
          </Grid.Child>

          {/* ICON */}

          <Grid.Child
            gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '1 / span 12' }}
            gridRow="1"
          >
            <Box
              paddingHorizontal={{ xs: '16x', md: '0' }}
              marginTop={{ xs: '54%', lg: '20%' }}
              zIndex="2"
              position="relative"
              display="flex"
              justifyContent={{ xs: 'left', md: 'center' }}
            >
              <Image
                alt="Icono de un candado"
                src="lite-version/card-lock-new.svg"
                width={{ xs: '80px', md: '120px' }}
                height={{ xs: '68px', md: '102px' }}
                webp
                loading="lazy"
              />
            </Box>

          </Grid.Child>

        </Grid>
      </Box>
    </Box>
  );
}

export default SecurityAndTransparency;
